export const SET_FEATURED_PERK = 'SET_FEATURED_PERK';

export const setFeaturedPerk = (perkId, nextRotationAt) => ({
  type: SET_FEATURED_PERK,
  payload: { perkId, nextRotationAt },
});
